export function getLocaleFromLang(lang?: string) {
  switch (lang) {
    case 'es':
      return 'es-ES'
    case 'fr':
      return 'fr-FR'
    default:
      return 'en-US'
  }
}
